
import { TabView, TabPanel } from 'primereact/tabview';
import ListaServiciosEnVivo from "./ListaServiciosEnVivo";
import ListaPorUnidades from "./ListaPorUnidades";

const ListaServicios = ({
    setListaRutasPanelIzquierdo,
    listaRutasPanelIzquierdo,
    setListaRutasPanelIzquierdoUnidad,
    listaRutasPanelIzquierdoUnidad,
    contadorPorMinuto,
    setCentrarUnidad,
    unidades,
    zona,
    cliente,
    tipoServicio,
    confirmadoNoConfirmado,
    confirmacion,
    activeIndex,
    setActiveIndex,
    setUnidadSeleccionada,
    unidadSeleccionada,
    setCoordenadasVistaUnidades,
    coordenadasVistaUnidades,
    unidadCoordenadas,
    servicios,
    setServicios,
    setDataUnidadVistaUnidad,
}) => {
    return (


        <TabView className="tab-view-tablero" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <TabPanel className="panelView" header="SERVICIOS EN VIVO">
                <ListaServiciosEnVivo
                    contadorPorMinuto={contadorPorMinuto}
                    listaRutasPanelIzquierdo={listaRutasPanelIzquierdo}
                    setListaRutasPanelIzquierdo={setListaRutasPanelIzquierdo}
                    setCentrarUnidad={setCentrarUnidad}
                    servicios={servicios}
                    setServicios={setServicios}
                    // filtros
                    zona={zona}
                    cliente={cliente}
                    tipoServicio={tipoServicio}
                    confirmadoNoConfirmado={confirmadoNoConfirmado}

                    activeIndex={activeIndex}
                    setActiveIndex={setActiveIndex}
                    unidades={unidades}

                    setUnidadSeleccionada={setUnidadSeleccionada}
                    unidadSeleccionada={unidadSeleccionada}


                ></ListaServiciosEnVivo>
            </TabPanel>
            <TabPanel className="panelView" header="UNIDADES">
                <ListaPorUnidades
                    listaRutasPanelIzquierdoUnidad={listaRutasPanelIzquierdoUnidad}
                    setListaRutasPanelIzquierdoUnidad={setListaRutasPanelIzquierdoUnidad}
                    setCoordenadasVistaUnidades={setCoordenadasVistaUnidades}
                    coordenadasVistaUnidades={coordenadasVistaUnidades}
                    setCentrarUnidad={setCentrarUnidad}
                    zona={zona}
                    contadorPorMinuto={contadorPorMinuto}
                    activeIndex={activeIndex}
                    unidadCoordenadas={unidadCoordenadas}
                    setDataUnidadVistaUnidad={setDataUnidadVistaUnidad}
                ></ListaPorUnidades>

            </TabPanel>
        </TabView >
    );
};

export default ListaServicios;